export function getClickQuadrant(event) {
    var clickX = event.clientX;
    var clickY = event.clientY;
    var halfWindowWidth = window.innerWidth / 2;
    var halfWindowHeight = window.innerHeight / 2;
    return {
        x: clickX > halfWindowWidth ? 'right' : 'left',
        y: clickY > halfWindowHeight ? 'bottom' : 'top',
    };
}
